import { FormlyTemplateOptions } from '@ngx-formly/core';
import { Observable } from 'rxjs';

// Local interfaces to avoid circular dependency with @lib/api
export interface ISearchListQueryParameters {
  search?: string;
  ordering?: string;
  page?: number;
  pageSize?: 'all' | number;
  [name: string]: any;
}

export interface ISearchListResponse<T> {
  count: number;
  results: T[];
  totalPages?: number;
}

export interface ISnSearchListTemplateOptions<M = any> extends FormlyTemplateOptions {
  valueProp?: keyof M;
  labelProp?: keyof M;
  secondaryLabelProp?: keyof M;
  searchPlaceholder?: string;
  multiple?: boolean;
  maxHeight?: string;
  debounceTime?: number;
  showLoading?: boolean;
  noResultsText?: string;
  
  /** Whether to filter results locally instead of server-side (default: false) */
  filterLocally?: boolean;

  /** Page size to use when loading all data for local filtering (default: 'all') */
  allDataPageSize?: number | string;

  /** Function to fetch data based on search query */
  fetchDataFn?(
    params: ISearchListQueryParameters,
    model: any,
    field: any,
  ): Observable<ISearchListResponse<M>>;
  
  selectionChange?(selected: M | M[]): void;
  
  trackByFn?(index: number, item: M): any;
}
